import { render, staticRenderFns } from "./end-of-year.vue?vue&type=template&id=2467839b"
import script from "./end-of-year.vue?vue&type=script&lang=js"
export * from "./end-of-year.vue?vue&type=script&lang=js"
import style0 from "./end-of-year.vue?vue&type=style&index=0&id=2467839b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports